import React from 'react';
import { AlertCircleIcon, TrendingUpIcon, ClipboardCheckIcon, ClockIcon } from 'lucide-react';
const suggestions = [{
  icon: <AlertCircleIcon size={16} className="text-red-500" data-id="element-144" />,
  text: 'Mangler: WiFi-termostater i stueplan'
}, {
  icon: <TrendingUpIcon size={16} className="text-green-500" data-id="element-145" />,
  text: 'Opsalg: Energiovervågning / CTS-integration'
}, {
  icon: <ClipboardCheckIcon size={16} className="text-blue-500" data-id="element-146" />,
  text: 'Forslag: Serviceaftale 24 mdr.'
}, {
  icon: <ClockIcon size={16} className="text-amber-500" data-id="element-147" />,
  text: 'Tjek: Leveringstid på manifold-størrelser'
}];
export function SidePanel() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sticky top-6" data-id="element-148">
      <h3 className="text-lg font-medium text-gray-800" data-id="element-149">
        Mangler & opsalg (AI)
      </h3>
      <div className="mt-4 space-y-4" data-id="element-150">
        {suggestions.map((item, index) => <div key={index} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg" data-id="element-151">
            <div className="mt-0.5" data-id="element-152">{item.icon}</div>
            <p className="text-sm text-gray-700" data-id="element-153">{item.text}</p>
          </div>)}
      </div>
      <p className="text-xs text-gray-400 mt-4" data-id="element-154">
        Autogenereret ud fra projektdata
      </p>
    </div>;
}